import React from 'react'

export const PartnerImageLink = ({
                                   src = "https://via.placeholder.com/400x300?text=Click+Me",
                                   alt = "Clickable image",
                                   link = "https://www.example.com",
                                   style = {}
                               }) => {
    const handleClick = () => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    return (
        <div style={{ display: 'block', margin: '12px' }}>
            <img
                src={src}
                alt={alt}
                onClick={handleClick}
                style={{
                    width: 'min(200px, 70vw)',
                    height: 'min(80px, 40vw)', // Maintains 16:10 aspect ratio
                    objectFit: 'fill',
                    cursor: 'pointer',
                    transition: 'opacity 0.2s ease',
                    ...style
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
            />
        </div>
    );
};

